export default {
  id: 200,
  title: 'Target #200 - Lantern',
  url: 'https://cssbattle.dev/play/200',
  colors: ['#FAD3E5', '#8B0051'],
  solution:
    '<p><style>body{background:linear-gradient(90deg,#fad3e5 175px,#8b0051 175px 225px,#fad3e5 225px)}p{position:fixed;background:#8b0051;top:4;left:144;width:112;height:140;rotate:63.5deg;transform:skewY(-37deg);box-shadow:107.5px 134.5px #8b0051',
}
